/* eslint-disable */
class StarItem {
  constructor(scene) {
    this.scene = scene;
    this.status = true;

    let rnd = Math.floor(Math.random() * 4);
    this.mesh = this.scene.getMeshByID("Star0" + (rnd + 1)).clone();

    this.mesh.rotation.x = (Math.random() * 360 * Math.PI) / 180;
    this.mesh.rotation.y = (Math.random() * 360 * Math.PI) / 180;
    this.mesh.rotation.z = (Math.random() * 360 * Math.PI) / 180;
    this.mesh.scaling.x = Math.random() * 10 + 1;
    this.mesh.scaling.z = this.mesh.scaling.x;

    this.flash();
  }

  flash() {
    if (this.status) {
      let time = Math.floor(Math.random() * 100) + 250;
      this.mesh.visibility = Math.random();

      setTimeout(() => {
        this.flash();
      }, time);
    }
  }

  getMesh() {
    return this.mesh;
  }

  finalize() {
    this.status = false;
    this.mesh.dispose();
  }
}
export default StarItem;
